<template>
  <!-- <router-link :to="routerLink" class="max-w-sm w-1/2 md:w-1/3"> -->

  <router-link
    :disabled="routerLink ? true : false"
    :to="routerLink || ''"
    class="flex-auto justify-center p-3 bg-transparent"
  >
    <div
      class="rounded-lg shadow-lg py-3 px-5 bg-gray-700"
      :class="`bg-${color}-700 hover:bg-${color}-800`"
      @click="$emit('click', id)"
    >
      <div class="flex flex-row items-center">
        <div class="flex-shrink">
          <unicon
            v-if="unicon"
            :name="unicon"
            :class="
              `text-${color}-100 hover:text-white w-10 h-10 sm:w-12 sm:h-12 hidden sm:inline`
            "
          />
        </div>
        <div class="pr-1 flex-grow text-right">
          <div
            :class="
              `text-${color}-200 hover:text-${color}-100 uppercase tracking-wide text-xs sm:text-sm font-bold leading-tight`
            "
          >
            {{ label }}
          </div>
          <div
            :class="
              `mt-2 text-${color}-100 hover:text-white text-2xl sm:text-4xl leading-none`
            "
          >
            <span>{{ value }}</span>
          </div>
        </div>
      </div>
    </div>
  </router-link>
  <!-- </router-link> -->
</template>

<script>
export default {
  name: 'TileCogs',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    value: {
      type: [String, Number],
      required: false,
      default: ''
    },
    routerLink: {
      type: String,
      required: false,
      default: null
    },
    unicon: {
      type: String,
      required: false,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: 'gray'
    },
    progressBarPercent: {
      type: Number,
      required: false,
      default: null
    }
  }
}
</script>
